import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CaseInfo } from '../components/casos/interfaces/caso_info.interface';
import { EnvService } from './env.service';

export interface Files {
  _id?: string;
  file_path: string;
  filename: string;
  date?: Date;
}

export class CasoTareaModel {
  _id?: string;
  solucion?: string;
  numero_caso: string;
  unidad: string;
  tipo_caso: string;
  asignadoA: string;
  asignadoAID: string;
  estado: string;
  historial: any[];
  files: any[];
  descripcion: string;
  aprobacion: boolean;
  aprobacionSupervisor: boolean;
  requiereDobleAprobacion: boolean;
  casoRemitido: string;
  remite: boolean;
  comentRevision: string;
  creadoPor: string;
  creadoPorc?: string;
  createdAt: Date;
  updatedAt: Date;
  archivetAt: Date;
  deleted: boolean;
  edit: boolean;
  validar_documento: string;
  fecha_realizacion: Date;
  email_usado: string;
  informado_correo: string;
  autorizar: string;
  patron_fraude: string;
  personType?: 'n' | 'j';
}
@Injectable({
  providedIn: 'root',
})
export class CasoTareaService {
  url = `${this.env.URL_API}/caso_tarea`;
  constructor(public http: HttpClient, private env: EnvService) {}

  post(caso: CasoTareaModel): Observable<any> {
    return this.http.post(`${this.url}`, caso);
  }

  put(id: string, caso: CasoTareaModel): Observable<any> {
    return this.http.put(`${this.url}/${id}`, caso);
  }

  get(): Observable<any> {
    return this.http.get(`${this.url}`);
  }

  getById(id: string): Observable<any> {
    return this.http.get(`${this.url}/get/${id}`);
  }
  getRecordByCaseId(id: string): Observable<any> {
    return this.http.get(`${this.url}/record/${id}`);
  }

  getInformationById(id: string): Observable<any> {
    return this.http.get<CaseInfo>(`${this.url}/information/${id}`);
  }
  getFilesById(id: string) {
    return this.http.get<Files[]>(`${this.url}/files/${id}`);
  }
  addFileToCase(id: string, file: Files) {
    return this.http.post<Files[]>(`${this.url}/files/${id}`, file);
  }

  removeFileFromCase(id: string, fileID: string) {
    return this.http.delete<Files[]>(`${this.url}/files/${id}/${fileID}`);
  }

  getAprobacion(): Observable<any> {
    return this.http.post(`${this.url}/aprobacion`, {});
  }

  getByNumeroCaso(numero_caso: string): Observable<any> {
    return this.http.get(`${this.url}/numero_caso/${numero_caso}`);
  }

  delete(id: string): Observable<any> {
    return this.http.delete(`${this.url}/${id}`);
  }

  graficasDataCreated(body): Observable<any> {
    return this.http.post(`${this.url}/graficasDataCreated`, body);
  }

  graficasDataArchived(body): Observable<any> {
    return this.http.post(`${this.url}/graficasDataArchived`, body);
  }

  graficasUnidadTipoCaso(body): Observable<any> {
    return this.http.post(`${this.url}/graficasUnidadTipoCaso`, body);
  }

  graficasCasosAnalista(body): Observable<any> {
    return this.http.post(`${this.url}/graficasCasosAnalista`, body);
  }

  graficasBoxplotTipoCaso(body): Observable<any> {
    return this.http.post(`${this.url}/graficasBoxplotTipoCaso`, body);
  }

  ultimosdiezcasoseditados(): Observable<any> {
    return this.http.post(`${this.url}/ultimosdiezcasoseditados`, { body: 0 });
  }

  getbyFilter(data): Observable<any> {
    return this.http.post(`${this.url}/filter`, data);
  }
}
